import $ from 'jquery';

// Cached DOM Elements
const $alertBar = $('.alert__bar');

/**
 * @method eventHandlers
 * Contains all DOM events
 */
const eventHandlers = () => {
    $alertBar.find('.alert__close').on('click', (e) => {
        e.preventDefault();
        setCookie('alert', 'hide', 24);
        $alertBar.addClass('alert__bar--hide');
    });
}


/**
 * @method checkCookie
 * Check if alert cookie is defined
 */
const checkCookie = () => {
    if(document.cookie.indexOf('alert') !== -1){
        $alertBar.addClass('alert__bar--hide');
    }  
}

/**
 * @method setCookie
 * Set alert cookie
 */
const setCookie = (name, value, hours) => {
    let expires = "";
    if (hours){
        const date = new Date();
        date.setTime(date.getTime()+(hours*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

/**
 * @method init
 * Initialize events during page load
 */
const init = (() => {
    if ($alertBar.length) {
        eventHandlers();
        if ($alertBar[0].dataset.alertHide == 'True')
            checkCookie();
    }
})();
